import { useEffect } from 'react'
import { css } from '@emotion/core'
import { Button, Modal, Segment } from '@waylay/react-components'
import { useModal } from 'react-modal-hook'
import { useToasts } from 'react-toast-notifications'
import { useHistory } from 'react-router-dom'
import { get } from 'lodash-es'

import { TemplateContainer } from './useTemplate'

const useModalView = ({ id }) => {
  const { remove } = TemplateContainer.useContainer()
  const history = useHistory()
  const { addToast } = useToasts()

  const onSubmit = () => {
    remove.run(id)
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal isOpen onRequestClose={hideModal}>
        <Segment.Group
          css={css`
            width: 600px;
          `}
        >
          <Segment.Header>Delete template</Segment.Header>
          <Segment>
            Deleting <strong>{id}</strong> is permanent. Are you sure you wish
            to continue?
          </Segment>
          <Modal.Actions>
            <Button outline kind="secondary" onClick={hideModal}>
              Cancel
            </Button>
            <Button
              kind="danger"
              disabled={remove.isLoading}
              loading={remove.isLoading}
              onClick={() => onSubmit()}
            >
              Delete template
            </Button>
          </Modal.Actions>
        </Segment.Group>
      </Modal>
    ),
    [remove],
  )

  // we have to subscribe to the promise that gets created when we call `run`
  useEffect(() => {
    remove.promise
      .then(() => {
        hideModal()
        addToast(`Successfully deleted template ${id}`, {
          appearance: 'success',
        })
        history.push('/templates')
      })
      .catch((error: any) => {
        hideModal()
        const message = get(error, 'response.data.error', error.message)
        addToast(`Failed to delete: ${message}`, { appearance: 'error' })
      })
  }, [remove.promise])

  return [showModal, hideModal]
}

export default useModalView
